import { days_between_dates } from './../function/common.js';

export function purchase_summary__element(data){

	let $content = '';
	let $data = '';
	
	$content = $('<section/>', {
		'class': 'card trip__summary',
	});
	$data = `
		<div class="entry entry__events">
			<div class="entry__icon">
				<span class="material material-symbols-outlined">
					calendar_month
				</span>
			</div>
			<div class="entry__info">
				<span class="entry__info">Trip Length (${days_between_dates(data.start_date, data.end_date)} Nights)</span>
			</div>
		</div>
		
		<div class="entry entry__events">
			<div class="entry__icon">
				<span class="material material-symbols-outlined">
					text_snippet
				</span>
			</div>
			<div class="entry__info">
				<span class="entry__info">Word Count (${data.word_count})</span>
			</div>
		</div>
		
		<div class="entry entry__events">
			<div class="entry__icon">
				<span class="material material-symbols-outlined">
					photo_camera
				</span>
			</div>
			<div class="entry__info">
				<span class="entry__info">Media (${data.media_count})</span>
			</div>
		</div>
		
		<div class="entry entry__events">
			<div class="entry__icon">
				<span class="material material-symbols-outlined">
					explosion
				</span>
			</div>
			<div class="entry__info">
				<span class="entry__info">Events (${data.event_count})</span>
			</div>
		</div>
		
		<div class="entry entry__participants">
			<div class="entry__icon">
				<span class="material material-symbols-outlined">
					universal_currency
				</span>
			</div>
			<div class="entry__info">
				<span class="entry__info">Cost/Person (&dollar;${data.expenses_per_person_total})</span>
			</div>
		</div>
		
		<div class="entry entry__participants">
			<div class="entry__icon">
				<span class="material material-symbols-outlined">
					group
				</span>
			</div>
			<div class="entry__info">
				<span class="entry__info--sub">Adults (${data.adult_count})</span>
				<span class="entry__info--sub">Children (${data.child_count})</span>
			</div>
		</div>
	`;
	
	$content.append($data);
	return $content;
	
}
